import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 gutter--md" }
const _hoisted_2 = { class: "layout gutter--md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "flex xs12" }, [
    /*#__PURE__*/_createTextVNode(" Complete this form to suggest a new Protocol / Project to include in Notifi. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("New requests are reviewed and enabled once verified. ")
  ])
], -1)
const _hoisted_4 = { class: "flex xs12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "OR", -1)
const _hoisted_6 = { class: "pt-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Add")

import ProtocolSelector from "@/components/ProtocolSelector.vue";
import ChainsPicker from "@/components/ChainsPicker.vue";
import { Chain } from "@/models/Contract";
import { Protocol } from "@/models/Protocol";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { SiteStatus } from "@/notifi_types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const newName = ref("");
const newWebsite = ref("");
const newIcon = ref("");
const newDescription = ref("");
const newChains = ref<Chain[]>([]);
const owner = ref(false);
const ownerName = ref("");
const ownerEmail = ref("");
const discordServer = ref("");
const discordUser = ref("");

const urlRegex =
  /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;
const websiteError = computed(() => {
  return newWebsite.value.length > 5 && !urlRegex.test(newWebsite.value);
});
const websiteValid = computed(() => {
  return urlRegex.test(newWebsite.value);
});
const iconError = computed(() => {
  return newIcon.value.length > 5 && !urlRegex.test(newIcon.value);
});

const iconValid = computed(() => {
  return newIcon.value.length == 0 || urlRegex.test(newIcon.value);
});

const showAdd = ref(false);

const setNewChains = (chains: Chain[]) => {
  newChains.value.splice(0, newChains.value.length, ...chains);
};

const nameValid = computed(() => {
  return newName.value.length > 3;
});

const ownerEmailValid = computed(() => {
  return ownerEmail.value.length > 3;
});

const discordInviteValid = computed(() => {
  const test = /https:\/\/discord\.gg\/[0-9A-z]{8}/is;
  return test.test(discordServer.value);
});

const discordUserValid = computed(() => {
  return !/@.+/.test(discordUser.value);
});

const ownerDiscordValid = computed(() => {
  return discordInviteValid.value && discordUserValid.value;
});

const ownerValid = computed(() => {
  return (
    owner.value == false || ownerEmailValid.value || ownerDiscordValid.value
  );
});

const valid = computed(() => {
  return (
    nameValid.value &&
    websiteValid.value &&
    newChains.value.length > 0 &&
    iconValid.value &&
    ownerValid.value
  );
});

const addProtocol = async (): Promise<void> => {
  if (!valid.value) {
    throw "Please Complete all fields";
  }
  let p = Protocol.spawn(newName.value, newWebsite.value);
  try {
    p.chains = newChains.value;
    p.protocolSiteStatus = SiteStatus.requested;
    if (newIcon.value) p.iconURL = newIcon.value;
    if (newDescription.value) p.description = newDescription.value;
    p = await p.save();
    const ps = await p.makeProtocolStatus();
    if (owner.value) {
      if (ownerName.value) ps.claimName = ownerName.value;
      if (ownerEmail.value) ps.claimEmail = ownerEmail.value;
      if (discordServer.value) ps.discordServer = discordServer.value;
      if (discordUser.value) ps.discordUser = discordUser.value;
      ps.claimStarted = true;
    } else {
      ps.claimStarted = false;
    }
    await ps.save();
    showAdd.value = false;
  } catch (err: any) {
    console.log(err);
    alert(err.message);
  }
};

const router = useRouter();
const protocolSubscribe = (aProtocol: Protocol) => {
  router.push(`/subscription/protocol?protocolID=${aProtocol.id}`);
  //router.push(`/subscription/protocol`);
};

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ProtocolSelector, {
        showSearch: true,
        showVote: true,
        showSubscribe: true,
        showUserInfo: false,
        allowSelect: false,
        showStatus: true,
        showAdd: true,
        onAdd: _cache[0] || (_cache[0] = ($event: any) => (showAdd.value = true)),
        onSubscribe: protocolSubscribe
      })
    ]),
    _createVNode(_component_va_modal, {
      modelValue: showAdd.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showAdd).value = $event)),
      "hide-default-actions": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_va_input, {
            class: "flex xs12",
            modelValue: newName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newName).value = $event)),
            label: "Protocol Name",
            messages: "Required",
            success: _unref(nameValid)
          }, null, 8, ["modelValue", "success"]),
          _createVNode(_component_va_input, {
            class: "flex xs12",
            modelValue: newWebsite.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newWebsite).value = $event)),
            label: "Protocol Website",
            placeholder: "http://www.myProtocol.xyz",
            messages: "Required",
            error: _unref(websiteError),
            success: _unref(websiteValid)
          }, null, 8, ["modelValue", "error", "success"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ChainsPicker, {
              onSelected: setNewChains,
              required: ""
            })
          ]),
          _createVNode(_component_va_input, {
            class: "flex xs12",
            modelValue: newIcon.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newIcon).value = $event)),
            label: "Icon URL",
            placeholder: "http://www.myProtocol.xyz/coolProtocolIcon.svg",
            messages: "Optional",
            error: _unref(iconError)
          }, null, 8, ["modelValue", "error"]),
          _createVNode(_component_va_input, {
            class: "flex xs12",
            modelValue: newDescription.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newDescription).value = $event)),
            label: "Description",
            type: "textarea",
            messages: "Optional",
            placeholder: "Enter a description of the protocol / project"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_va_checkbox, {
            modelValue: owner.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((owner).value = $event)),
            label: "Protocol Manager / Owner"
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_va_input, {
              modelValue: ownerName.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ownerName).value = $event)),
              label: "Your Name",
              placeholder: "Joe Protocol",
              messages: "Optional"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_divider, { inset: "" }),
            _createVNode(_component_va_input, {
              modelValue: ownerEmail.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ownerEmail).value = $event)),
              label: "Your Email",
              placeholder: "dev@myprotocol.xyz"
            }, null, 8, ["modelValue"]),
            _hoisted_5,
            _createVNode(_component_va_input, {
              class: "flex sm7",
              label: "Protocol Discord Server Invite",
              modelValue: discordServer.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((discordServer).value = $event)),
              placeholder: "https://discord.gg/8ryhkfkfk"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_input, {
              class: "flex sm4",
              label: "Manager's Discord User Name",
              modelValue: discordUser.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((discordUser).value = $event)),
              placeholder: "@protocolMaster"
            }, null, 8, ["modelValue"])
          ], 512), [
            [_vShow, owner.value]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (showAdd.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              onClick: addProtocol,
              disabled: !_unref(valid)
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})